'use client';

/**
 * Socure DocV v5 Web SDK loader — a sink, not reactive state. Loads the
 * bundle once and runs deferred work once it's ready via a simple onload
 * queue.
 */

const SOCURE_SCRIPT_LOAD_TIMEOUT_MS = 10_000;

let started = false;
let loaded = false;
const pending: Array<() => void> = [];

export function loadSocure(onError?: () => void): void {
    if (typeof window === 'undefined' || started) return;
    started = true;

    // If a stale tag exists from a prior (failed) attempt, drop it and reload.
    const existing = document.querySelector('script#socure-docv-sdk');
    existing?.remove();

    const script = document.createElement('script');
    script.id = 'socure-docv-sdk';
    // cache-busting to avoid stale bundle issues
    script.src = `https://websdk.socure.com/bundle.js?t=${Date.now()}`;
    script.async = true;
    script.defer = true;

    let settled = false;
    const fail = (): void => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        script.onload = null;
        script.onerror = null;
        script.remove();
        started = false;
        loaded = false;
        pending.splice(0);
        onError?.();
    };
    const timeoutId = window.setTimeout(fail, SOCURE_SCRIPT_LOAD_TIMEOUT_MS);

    script.onload = (): void => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        script.onload = null;
        script.onerror = null;
        loaded = true;
        for (const fn of pending.splice(0)) fn();
    };
    script.onerror = fail;
    document.body.append(script);
}

/** Run `fn` once the Socure SDK is loaded, loading it on first use. */
export function socureExecuteOnLoad(fn: () => void): void {
    if (typeof window === 'undefined') return;
    if (!started) loadSocure();
    if (loaded) {
        fn();
    } else {
        pending.push(fn);
    }
}
